import React, { useEffect, useState } from "react";
import Topbar from "../../Layouts/Topbar";
import Header from "../../Layouts/Header";
import InnerBanner from "../../Layouts/InnerBanner";
import Footer from "../../Layouts/Footer";
import { API } from "../../constants";
import useCompanyStore from "../../hooks/useCompanyStore";

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(false);
  const { companyId } = useCompanyStore();

  const fetchPolicies = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        API.LIST_POLICIES + "/privacyPolicy" + "/" + companyId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Something went wrong");
      }
      setPolicy(result.data);
    } catch (error) {
      console.error("Fetch Policies Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!companyId) return;

    fetchPolicies();
  }, [companyId]);

  return (
    <>
      <Topbar />
      <Header />
      <InnerBanner />

      <section className="py-5 bg-light">
        <div className="container">
          {loading ? (
            <p>Loading...</p>
          ) : policy ? (
            <div className="bg-white shadow rounded p-4">
              <div
                className="policy-content"
                dangerouslySetInnerHTML={{
                  __html: policy.content || "",
                }}
              />
            </div>
          ) : (
            <div className="bg-white shadow rounded p-4">
              <h2>Privacy Policy</h2>
              <p>No privacy policy content found.</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
